import FeatureGates from '@atlaskit/feature-gate-js-client';
import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';

export function isEligibleForStandardTrialsUserAndStorageLimitBreakers(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		isInTrial,
		isInPredunning,
		isInvoiceable,
		licensedUsers,
		canAddPaymentDetails,
		trialDaysLeft,
		storageUsageInGB,
		automationFreeLimitStatus,
	} = context;

	const isOnFirstTrialDay = !!(trialDaysLeft && trialDaysLeft === 14);
	const isOverUserLimit = licensedUsers > 10;
	const isOverStorageUsageLimit = !!(storageUsageInGB && storageUsageInGB > 2);

	if (fg('growth_automation_limits_kill_switch')) {
		if (automationFreeLimitStatus) {
			const cohort = FeatureGates.getExperimentValue<string>(
				'growth_automation_limits_experiment',
				'cohort',
				'not-enrolled',
				{ fireExperimentExposure: false },
			);

			if (cohort !== 'not-enrolled') {
				return false;
			}
		}
	}

	if (
		product === 'confluence' &&
		edition === 'standard' &&
		fg('connie_edition_awareness_standard_trials_gate')
	) {
		return !!(
			(isInTrial || isInPredunning) &&
			isInvoiceable === false &&
			canAddPaymentDetails &&
			!isOnFirstTrialDay &&
			(isOverUserLimit || isOverStorageUsageLimit)
		);
	}

	if (
		product === 'jira' &&
		edition === 'standard' &&
		fg('jira_edition_awareness_standard_trials_gate')
	) {
		return !!(
			isInTrial &&
			isInvoiceable === false &&
			canAddPaymentDetails &&
			!isOnFirstTrialDay &&
			(isOverUserLimit || isOverStorageUsageLimit)
		);
	}

	return false;
}
